/*-----------------------------------------------------------------
- Market filter
-----------------------------------------------------------------*/
export default {
    search: {
        label      : 'جستجو در نتایج',
        placeholder: 'نام محصول را وارد کنید',
    },
    categories        : 'دسته‌بندی',
    ware_is_available : 'کالاهای موجود',
    has_discount      : 'محصولات تخفیف دار',
    remove_filters    : 'حذف',
    remove_all_filters: 'پاک کردن همه',
    applied_filters   : 'فیلتر‌های اعمال شده',
    filters           : 'فیلترها',
};
